export default "__VITE_ASSET__BmuheRCY__"